/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2023 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2023 - Finnish Meteorological Institute (FMI)
 * Copyright 2024 - The Norwegian Meteorological Institute (MET Norway)
 * */

import i18n from 'i18next';
import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';
import { safelyInitI18nForTestsAndStories } from '@opengeoweb/shared';
import timesliderTranslations from '../../../locales/timeslider.json';

export const TIME_SLIDER_NAMESPACE = 'timeslider';

export const initTimesliderI18n = (): void => {
  safelyInitI18nForTestsAndStories(i18n, TIME_SLIDER_NAMESPACE, [
    { ns: TIME_SLIDER_NAMESPACE, translations: timesliderTranslations },
  ]);
};

export const translateInTestsAndStories = (
  key: string,
  params: Record<string, string | number> | undefined = undefined,
): string => i18n.t(key, { ns: [TIME_SLIDER_NAMESPACE], ...params });

export const useTimesliderTranslation = (): UseTranslationResponse<
  typeof TIME_SLIDER_NAMESPACE,
  typeof i18n
> => useTranslation(TIME_SLIDER_NAMESPACE);
